import { render } from "./uiGridItemCol.vue?vue&type=template&id=97e554bc&scoped=true"
import script from "./uiGridItemCol.vue?vue&type=script&lang=js"
export * from "./uiGridItemCol.vue?vue&type=script&lang=js"

import "./uiGridItemCol.vue?vue&type=style&index=0&id=97e554bc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97e554bc"]])

export default __exports__